import React from "react";
import HeroSection from "./sections/HeroSection";
import CarriersStrip from "./sections/CarriersStrip";
import ServicesSection from "./sections/ServicesSection";
import SavingsCarousel from "./SavingsCarousel";
import WhySection from "./sections/WhySection";
import CaseStudies from "./CaseStudies";
import StatsRibbon from "./StatsRibbon";
import SecureFamilySection from "./sections/SecureFamilySection";
import TeamSection from "./sections/TeamSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import QuoteSection from "./sections/QuoteSection";

export default function HomePage() {
  return (
    <div id="top" className="bg-white">
      <HeroSection />
      <CarriersStrip />
      <ServicesSection />
      <SavingsCarousel />
      <WhySection />
      <CaseStudies />
      <StatsRibbon />
      <SecureFamilySection />
      <TeamSection />
      <TestimonialsSection />
      <QuoteSection />
    </div>
  );
}
